import React, { useEffect, useState, useMemo } from "react";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { Icon, Message } from "semantic-ui-react";
import CardBillingSummaryUX from "./CardBillingSummaryUX";
import { useIntl } from "react-intl";

const CARD_BILLING_SUMMARY = "CardBillingSummary";

const CardBillingSummary = (props: any) => {
  const intl = useIntl();
  useEffect(() => {
    props.runSequence({
      sequence: "BillingHistory",
      action: "get_summary",
      restart: true,
    });

    let errorMessage = props.errorMessage;
    let { [`${CARD_BILLING_SUMMARY}_SAVE`]: e, ...restError } = errorMessage || {};
    props.setProp("errorMessage", restError);
  }, []);

  const receiptsLength = props?.billingHistorySequence?.reportSummary?.receipts.length;

  const formatComma = (val: any) =>
    !isNaN(parseFloat(val))
      ? parseFloat(val)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(?:\d{3})+(?!\d))/g, ",")
      : val;

  const billingSummaryData = useMemo(() => {
    const list = props?.billingHistorySequence?.reportSummary?.receipts || [];

    const renderCell = (value, isLast) => (
      <div
        style={{
          textAlign: "right",
          ...(isLast && {
            fontWeight: "bold",
            textDecoration: "underline",
          }),
        }}
      >
        {formatComma(value)}
      </div>
    );

    return list.map((item, index) => {
      const isLast = list.length === index + 1;

      return {
        ...item,
        payment_total: renderCell(item?.payment_total, isLast),
        payment_cash: renderCell(item?.payment_cash, isLast),
        payment_transfer: renderCell(item?.payment_transfer, isLast),
        payment_credit: renderCell(item?.payment_credit, isLast),
        payment_debit: renderCell(item?.payment_debit, isLast),
        payment_cheque: renderCell(item?.payment_cheque, isLast),
        payment_coupon: renderCell(item?.payment_coupon, isLast),
        payment_refund: renderCell(item?.payment_refund, isLast),
      };
    });
  }, [props?.billingHistorySequence?.reportSummary]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <CardBillingSummaryUX
        style={{ zoom: "90%" }}
        stationSummary={props?.billingHistorySequence?.reportSummary}
        billingSummaryData={billingSummaryData}
        buttonRefresh={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={() => {
              props.runSequence({
                sequence: "BillingHistory",
                action: "get_summary",
                buttonLoadKey: `${CARD_BILLING_SUMMARY}_REFRESH`,
              });
            }}
            // data
            paramKey={`${CARD_BILLING_SUMMARY}_REFRESH`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_BILLING_SUMMARY}_REFRESH`]}
            // config
            style={{ width: "100%" }}
            title={
              <div>
                <Icon name="refresh"></Icon>
                refresh
              </div>
            }
            color="blue"
          />
        }
        buttonPrint={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={() => {
              props.runSequence({
                sequence: "BillingHistory",
                action: "print_summary",
                buttonLoadKey: `${CARD_BILLING_SUMMARY}_PRINT`,
                will_close: false,
                will_print: true,
              });
            }}
            // data
            paramKey={`${CARD_BILLING_SUMMARY}_PRINT`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_BILLING_SUMMARY}_PRINT`]}
            // config
            style={{ width: "100%" }}
            title={intl.formatMessage({ id: "พิมพ์ใบสรุปยอดระหว่างกะ" })}
            color="blue"
          />
        }
        buttonSave={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={() => {
              props.runSequence({
                sequence: "BillingHistory",
                action: "print_summary",
                buttonLoadKey: `${CARD_BILLING_SUMMARY}_SAVE`,
                will_close: true,
                will_print: false,
              });
            }}
            // data
            paramKey={`${CARD_BILLING_SUMMARY}_SAVE`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_BILLING_SUMMARY}_SAVE`]}
            // config
            style={{ width: "100%" }}
            title={intl.formatMessage({ id: "ปิดกะและพิมพ์ใบสรุปยอด" })}
            color="green"
          />
        }
        errorMessage={
          <div>
            {props.errorMessage?.[`${CARD_BILLING_SUMMARY}_SAVE`] != null && (
              <Message color="red">
                <li>{props.errorMessage?.[`${CARD_BILLING_SUMMARY}_SAVE`]}</li>
              </Message>
            )}
          </div>
        }
        languageUX={props.languageUX}
      />
    </div>
  );
};

export default CardBillingSummary;
